export const API_ROUTES = {
  FINPSP: {
    DEPOSIT: '/finpsp/deposit',
    WITHDRAW: '/finpsp/withdraw',
    PAYMENT: (transactionId: string) => `/finpsp/payments/${encodeURIComponent(transactionId)}`,
  },
  ZERO_X: {
    WITHDRAWALS: '/zero-x-processing/withdrawals',
    WITHDRAWAL_PREVIEW: '/zero-x-processing/withdrawals/preview',
    WITHDRAWAL_CURRENCIES: '/zero-x-processing/withdrawals/currencies',
    CURRENCIES: '/zero-x-processing/deposits/currencies',
    DEPOSIT_MINIMUM: '/zero-x-processing/deposits/minimum',
    ADDRESS: '/zero-x-processing/deposits/address',
  },
  LIGDICASH: {
    INITIATE_DEPOSIT: '/ligdicash/initiate/deposit',
    DEPOSIT: '/ligdicash/deposit',
    WITHDRAW: '/ligdicash/withdraw',
  },
  KAPOPAY: {
    DEPOSIT: '/kapopay/deposit',
    WITHDRAW: '/kapopay/withdraw',
  },
  CRYPTO: {
    DEPOSIT: '/crypto/deposit',
    WITHDRAW: '/crypto/withdraw',
    EXCHANGE_RATE: '/crypto/exchange/rate',
  },
  WELCOME_BONUS: {
    AVAILABILITY: 'customer/welcome-bonus/availability',
    SELECTION: 'customer/welcome-bonus/selection',
  },
  COMPLY_CUBE: {
    FLOW_SESSION: 'comply-cube/flow-session',
  },
  FIRST_DEPOSIT_BONUS: {
    FORFEIT: '/bonus/first-deposit/forfeit',
    PROGRESS: '/bonus/first-deposit/progress-bar',
  },
  JACKPOTS: {
    POOLS: 'jackpots/pools',
    POOL_STATISTICS: (jackpotId: string) => `jackpots/pool/${jackpotId}`,
  },
  MY_BETS: '/betting-slips/my-bets',
  WALLET_TRANSACTION_TOTALS: {
    PLAYER: 'transactions/account/totals',
    BACKOFFICE: 'transactions/bo/account/totals',
  },
  WALLET_TRANSACTIONS_HISTORY: {
    PLAYER: 'transactions/history',
    BACKOFFICE: 'transactions',
  },
  BETTING_HISTORY: {
    PLAYER: 'betting-slips/history',
    BACKOFFICE: 'bo/betting-slips/history',
  },
  BET_BUILDER: {
    CALCULATE: (eventId: string) => `fixtures/${eventId}/bet-builder`,
  },
  EVENTS: {
    PUBLISHED: 'events/published',
    PUBLISHED_GROUPED: 'events/published/grouped',
    PUBLISHED_GROUPED_FEATURED_TOURNAMENTS: 'events/published/grouped/featured-tournaments',
  },
  TOURNAMENTS: {
    WITH_EVENTS: 'tournaments/with-events',
  },
  CASINO_TRANSACTIONS_HISTORY: 'transaction/transactions?createdAt=desc',
} as const;
